module.exports = __webpack_public_path__ + "static/media/pic2.a50dbb62.jpg";